import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '../modules/components/Typography';
import { useInView } from 'react-intersection-observer';
import 'animate.css';
import './ImageModel.css';

const CaseDetails = (props) => {
  const { ref, inView } = useInView({
    // オプション
    rootMargin: '-100px', // ref要素が現れてから50px過ぎたら
    triggerOnce: true, // 最初の一度だけ実行
  });

  const [isOpen, setIsOpen] = useState(false);
  var [title, setTitle] = useState('');
  var [img_path, setImgPath] = useState('');
  var [messeage, setMesseage] = useState('');

  const handleOpen = (_title, _img_path, _message) => {
    setTitle(_title);
    setImgPath(_img_path);
    setMesseage(_message);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Container sx={{ pt: 8, pb: 4, mb: 5 }}>
      <Typography variant="h2" align="center" component="h1">
        {props.title}
      </Typography>
      <Box sx={{ mt: 10, ml: 0, minHeight: '50vh' }}>
        <Grid container spacing={2} columns={{ xs: 2, md: 4 }}>
          {props.cards.map((card, index) => (
            <Grid item xs={2} md={2} key={index} align="center">
              <div ref={ref}>
                {inView && (
                  <div className={`${props.animation}`}>
                    <Box
                      component="img"
                      alt={card.title}
                      src={card.img_path}
                      width={{ xs: '100%', md: '100%' }}
                      onClick={() => {
                        handleOpen(card.title, card.img_path, card.message);
                      }}
                    />
                  </div>
                )}
              </div>
            </Grid>
          ))}
          {isOpen && (
            <div onClick={handleClose} className="modal-overlay">
              <div className="modal-content">
                <img src={img_path} alt={title} />
                <Typography
                  variant="h5"
                  align="center"
                  component="h5"
                  sx={{ color: '#eeeeee', maxWidth: '80%', mt: 5, ml: 'auto', mr: 'auto' }}
                >
                  {messeage}
                </Typography>
              </div>
              <div className="nonScroll"></div>
            </div>
          )}
        </Grid>
      </Box>
    </Container>
  );
};

export default CaseDetails;
